import NumberedChart from './NumberedChart'

export default NumberedChart
